<template>
    <v-tabs-items v-model="tab" touchless class="h-100">
        <slot v-bind="{ tab, prev, next }" />
    </v-tabs-items>
</template>

<script>
import { TABS } from "./lib";

let tabs = Object.keys(TABS);

export default {
    props: {
        value: { type: String, default: TABS.SCAN.value },
    },
    data: () => ({
        tab: TABS.SCAN.value,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.tab = this.value;
        },
        emit() {
            this.$emit("input", this.tab);
        },
        prev() {
            let index = tabs.findIndex((tab) => tab == this.tab);
            if (0 < index) this.tab = tabs[index - 1];
            this.emit();
        },
        next(tab) {
            let index = tabs.findIndex((tab) => tab == this.tab);
            if (index < tabs.length - 1) this.tab = tabs[index + 1];
            this.emit();
        },
    },
};
</script>

<style></style>
